/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { list2 } from '~/actions/customersNew';
import Table from 'react-toolbox/lib/table';
import { Button } from 'react-toolbox/lib/button';
import Spinner from '~/components/Spinner';

class Page extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      skipId: null,
      more: false,
      results: [],
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, null)
      .then(r => this.setState({
        loading: false,
        skipId: r.data.skipId,
        more: r.data.more,
        results: r.data.results,
      }));
  }

  searchMore() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, this.state.skipId)
      .then(r => this.setState({
        loading: false,
        skipId: r.data.skipId,
        more: r.data.more,
        results: [...this.state.results, ...r.data.results],
      }));
  }

  render() {
    const rows = Object.values(this.props.items)
      .filter(i => this.state.results.find(r => r.id === i.id))
      .filter(i => !i.removed);
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ display: 'flex' }}>
          <span style={{ fontSize: '1.5rem' }}>Customers</span>
          <span style={{ flexGrow: 1 }} />
          <Button
            label="New Customer"
            onClick={() => this.context.dialogPush('customersNew', { editMode: true, onCreate: () => this.search() })}
            primary
            raised
            icon="add"
          />
        </div>
        <form style={{ margin: '5px' }} onSubmit={e => { e.preventDefault(); this.search(); }}>
          <input
            style={{ height: '38px', width: '300px' }}
            placeholder="Search FirstName, LastName, Company, Email, Phone, Id"
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <Button label="Find" primary raised type="submit" />
        </form>
        <Table
          selectable={false}
          model={{
            firstName: { type: String },
            lastName: { type: String },
            company: { type: String },
            email: { type: String },
            phone: { type: String },
            country: { type: String },
          }}
          source={rows}
          onRowClick={(i) => this.context.dialogPush('customersNew', { id: rows[i].id, editMode: true })}
        />
        {<div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
          {this.state.loading && <Spinner />}
          {!this.state.loading && rows.length === 0 && <div>No customers found</div>}
          {!this.state.loading && this.state.more && <Button
            label="Load more"
            primary
            raised
            onClick={() => this.searchMore()}
          />}
        </div>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['customersNew', 'items']).toJS(),
});

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./app/pages/CustomersNew/index.js